import { render } from "./dokumen_opd..vue?vue&type=template&id=ed068ad2&scoped=true"
import script from "./dokumen_opd..vue?vue&type=script&lang=js"
export * from "./dokumen_opd..vue?vue&type=script&lang=js"

import "./dokumen_opd..vue?vue&type=style&index=0&id=ed068ad2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed068ad2"]])

export default __exports__